import { FunctionComponent } from "react"
import { useTypedSelector } from "../app/store"
import DemoAuth from "../features/auth/components/demo-auth"
import { Navigate, useLocation } from "react-router-dom"

type AuthGateProps = {
  children: React.ReactNode
}

const AuthGate: FunctionComponent<AuthGateProps> = ({ children }) => {
  const user = useTypedSelector((state) => state.authSlice.user)
  const location = useLocation()

  if (!user?.id) {
    document.body.classList.remove("meseekna-authed")
    if (process.env.REACT_APP_DEMO_MODE?.toLowerCase() === "true") {
      return <DemoAuth />
    }
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  document.body.classList.add("meseekna-authed")
  return <>{children}</>
}

export default AuthGate
